import React from "react";
import { Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { MiddleBannerItem } from "../types/MiddleBannerItem";

interface MiddleBannerSectionProps {
    items: MiddleBannerItem[];
}

const SLIDE_MIN_HEIGHT = 300;

const MiddleBannerSection: React.FC<MiddleBannerSectionProps> = ({ items }) => {
    if (!items || items.length === 0) return null;

    // Un solo banner sin carrusel ni flechas
    if (items.length === 1) {
        return (
            <Box sx={{ my: 6 }}>
                <MiddleBannerItemRenderer item={items[0]} />
            </Box>
        );
    }

    return (
        <Box sx={{ my: 6, position: "relative" }}>
            <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                autoplay={{ delay: 6000 }}
                loop
                pagination={{ clickable: true }}
                navigation={{
                    nextEl: ".swiper-button-next-middle",
                    prevEl: ".swiper-button-prev-middle",
                }}
            >
                {items.map((item) => (
                    <SwiperSlide key={item.key}>
                        <MiddleBannerItemRenderer item={item} />
                    </SwiperSlide>
                ))}
            </Swiper>

            <Box
                className="swiper-button-prev-middle"
                sx={{
                    position: "absolute",
                    left: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 10,
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    color: "black",
                    "&::after": {
                        content: '"‹"',
                        fontSize: 34,
                    },
                }}
            />

            <Box
                className="swiper-button-next-middle"
                sx={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 10,
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    color: "black",
                    "&::after": {
                        content: '"›"',
                        fontSize: 34,
                    },
                }}
            />
        </Box>
    );
};

export default MiddleBannerSection;


const MiddleBannerItemRenderer: React.FC<{ item: MiddleBannerItem }> = ({ item }) => {
    return (
        <Box
            sx={{
                minHeight: SLIDE_MIN_HEIGHT,
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            {/*  Banner complejo */}
            {item.type === "component" ? (
                <Box sx={{ width: "100%" }}>
                    {item.component}
                </Box>
            ) : (
                /* ?? Banner imagen */
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "#f5f5f5",
                    }}
                >
                        <Box
                            component="img"
                            src={item.banner.imagenUrl}
                            alt={item.banner.descripcion}
                            sx={{
                                width: "100%",
                                height: {
                                    xs: 120,
                                    sm: 180,
                                    md: "auto",
                                },
                                objectFit: {
                                    xs: "cover",
                                    md: "contain",
                                },
                                objectPosition: "center",
                                display: "block",
                            }}
                        />


                </Box>
            )}
        </Box>
    );
};














